export const BLOOD_PRESSURE_CHART = [
  {
    label: "Blood Pressure",
    value: [
      {
        key: "systolic",
        color: "#8884d8",
        bounds: [120],
      },
      { key: "diastolic", color: "#82ca9d", bounds: [80] },
      { key: "bpm", color: "#3182BD" },
    ],
  },
];

export const PULSE_PRESSURE_CHART = [
  {
    label: "Central Pulse Pressure",
    value: [
      {
        key: "central_pulse_pressure",
        color: "#92C8A0",
        name: "mmHg",
      },
    ],
  },
];

export const PULSE_PRESSURE_AMPLIFICATION_CHART = [
  {
    label: "Pulse Pressure Amplification",
    value: [
      {
        key: "pulse_pressure_amplification",
        color: "#e4a30bff",
        name: "%",
      },
    ],
  },
];

export const CENTRAL_SYSTOLIC_PRESSURE_CHART = [
  {
    label: "Central Systolic Pressure",
    value: [
      {
        key: "systolic",
        color: "#8784D2",
        name: "mmHg",
      },
    ],
  },
];
